var _rect, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuCamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.230469,
    y: 0.707031,
    width: 111,
    height: 111,
    rx: 30.2727,
    fill: "#4359F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5727 37.2866H80.9576C86.5306 37.2866 91.0485 41.8044 91.0485 47.3775V75.1275C91.0485 80.7005 86.5306 85.2184 80.9576 85.2184H30.503C24.93 85.2184 20.4121 80.7005 20.4121 75.1275V47.3775C20.4121 41.8044 24.93 37.2866 30.503 37.2866H38.1493C38.77 32.3088 43.0162 28.457 48.1621 28.457H64.5598C69.7057 28.457 73.952 32.3088 74.5727 37.2866Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5156,
    cy: 61.2524,
    r: 13.875,
    fill: "#C9D8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 53.209,
    cy: 57.4683,
    r: 13.875,
    fill: "#4359F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuCamIcon);
export default __webpack_public_path__ + "static/media/zunu_cam_icon.275be07b2b4443a92e4ad2d3ff198eb8.svg";
export { ForwardRef as ReactComponent };